<template>
    <div>
        <Card shadow>
            <Row :gutter="10">
                <Col span="7" style="display:none">
                    <label style="display: flex; align-items: center">
                        <span style="width: 80px">代理组:</span>
                        <Select v-model="table.params.platids" filterable placeholder="筛选所属分组" clearable multiple :max-tag-count="3" @on-change="updateSelect">
                            <Option v-for="(item, index) in plat_list" :value="item.id" :label="item.name" :key="index">
                                {{ item.name }}
                                <span style="color: #bbb">({{ item.id }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="5">
                    <label style="display: flex; align-items: center">
                        <span style="width: 50px">代理:</span>
                        <Select v-model="table.params.app_ids" filterable placeholder="筛选代理" multiple :disabled="!table.params.platids.length" :max-tag-count="3">
                            <Option v-for="(item, index) in app_list.filter((el) => table.params.platids.length == 0 || table.params.platids.includes(el.platform))" :value="item.appid" :label="item.appName" :key="index">
                                {{ item.appName }}
                                <span style="color: #bbb">({{ item.appid }})</span>
                            </Option>
                        </Select>
                    </label>
                </Col>
                <Col span="5">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">查询时间:</span>
                        <DatePicker type="date" format="yyyy-MM-dd" v-model="select.dataTime" placeholder="选择日期" :options="dateOptions" :clearable="false"></DatePicker>
                    </label>
                </Col>
                <Col span="5">
                    <label style="display: flex; align-items: center">
                        <span style="width: 120px">对比时间:</span>
                        <DatePicker type="date" format="yyyy-MM-dd" v-model="select.DdataTime" placeholder="选择日期" :options="dateOptions" :clearable="false"></DatePicker>
                    </label>
                </Col>
            </Row>
            <Row :gutter="18" style="margin-top: 12px">
                <Col style="display: flex; justify-content: space-between; width: 350px">
                    <Button type="primary" @click.native="TransTopReq()" :loading="loading">
                        <span v-if="!loading">查询</span>
                        <span v-else>loading..</span>
                    </Button>
                    <div>
                        <Button type="primary" @click.native="eleToExcel()" style="margin-right: 12px"> 导出Excel </Button>
                        <Button type="primary" @click.native="toPdf()"> 导出PDF </Button>
                    </div>
                </Col>
            </Row>
        </Card>
        <Table border :columns="table.columns" :data="table.data" style="margin-top: 12px" :max-height="maxHeight" ref="tableRef"></Table>
    </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import publicTable from '@/views/components/publicTable.vue'
export default {
    name: 'GameCompareDay',
    components: { publicTable },
    data() {
        return {
            maxHeight: 800,
            loading: false,
            TransTopReqTimer: null,
            select: {
                dataTime: this.getCurrentZeroDay(),
                DdataTime: this.getCurrentZeroDay()
            },

            table: {
                params: {
                    mod: 'root',
                    platid: 0,
                    platids: [],
                    app_id: 0,
                    app_name: '',
                    platform: 0,
                    app_ids: [],
                    param: {
                        _mod: 'manager',
                        _func: 'GetGameCompareInfo',
                        _param: {
                            platid: 0,
                            app_id: 0,
                            stime: 0,
                            etime: 0,
                            general: -1,
                            pack_no: -1
                        }
                    }
                },
                data: [],
                columns: [
                    {
                        title: '盘口',
                        key: 'app_name',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [h('span', params.row.app_name ? params.row.app_name : ''), h('span', { style: 'color:#bbb' }, params.row.app_id ? `（${params.row.app_id}）` : '')])
                        }
                    },
                    { title: '日期', key: 'idate', minWidth: 100, align: 'center' },
                    this.renderCol('active_user_num', '活跃人数', false),
                    this.renderCol('new_user_num', '新增人数', false),
                    this.renderCol('new_user_pay_num', '新增转入人数', false),
                    this.renderCol('pay_bet_num', '转入投注人数', false),
                    this.renderCol('pay_user_num', '转入人数', false),
                    {
                        title: '转入赢家数占比',
                        key: 'pay_winner_rate',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            let value = params.row.pay_winner_rate || 0
                            let color = this.rCol(params.row.type, value)
                            let str = (value * 100).toFixed(2) + '%'
                            return h('span', { style: { color } }, str)
                        }
                    },
                    this.renderCol('pay_total_times', '转入金额', true),
                    this.renderCol('r_pay_user_num', '大R人数', false),
                    this.renderCol('r_pay_user_sum', '大R转入金额', true),
                    this.renderCol('pay_ave', 'ARPPU', true)
                    // {
                    //     title: '线上支付成功率',
                    //     key: 'online_pay_rate',
                    //     minWidth: 100,
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         if (params.row.idate != '环比') {
                    //             return h(
                    //                 'span',
                    //                 {
                    //                     style: {
                    //                         color: this.rCol(params.row.type, params.row.online_pay_rate),
                    //                     },
                    //                 },
                    //                 (params.row.online_pay_rate * 100).toFixed(2) + '%'
                    //             );
                    //         } else {
                    //             //    return h("span", { style: {  color: this.rCol( params.row.type, params.row.online_pay_rate ), }, }, (params.row.online_pay_rate * 100).toFixed(2) + "%")
                    //             return h('span', '-');
                    //         }
                    //     },
                    // },
                ],
                total: 0,
                pageSizes: [10, 20, 30, 40]
            },
            all: this.allInit()
        }
    },
    methods: {
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 6000)
        },
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: this.table.params.platid,
                app_id: this.table.params.app_id,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },
        renderCol(key, title, ispoint = false) {
            return { title, key, minWidth: 100, align: 'center', render: (h, params) => this.rColItem(h, params, ispoint) }
        },
        async TransTopReq() {
            this.all = this.allInit()
            if (this.loading) return
            this.table.params.param._param.stime = this.getSecond(this.select.dataTime)
            this.table.params.param._param.etime = this.getSecond(this.select.dataTime, false)
            this.openTimer()
            let allList = this.getAllHttpAppid(this.table.params)
            this.table.data = []
            let dateMap = {}
            let httpList = []
            let loadingArr = [...allList]

            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let app_name = ''
                let platid = 0
                let item = this.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                }
                this.table.params.platid = platid
                this.table.params.app_id = app_id
                this.table.params.app_name = app_name
                this.table.params.param._param.app_id = app_id
                this.table.params.param._param.platid = platid
                let param = this.copyData(this.table.params)
                httpList.push(param)
            }
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, dateMap, loadingArr)
            }
        },

        async toHttp(httpList, dateMap, loadingArr) {
            if (httpList.length > 0) {
                let param = httpList[0]
                httpList.shift()
                let num = httpList.length
                //对比1游戏数据
                TransTopReq(param)
                    .then((res) => {
                        let compGameData1 = res._param
                        this.proGameBaseData(compGameData1, param)
                        let param2 = this.copyData(param)
                        param2.param._func = 'GetNewPlatfromData'
                        //对比1平台总数据
                        TransTopReq(param2).then((res2) => {
                            this.proPlatBaseData(res2, compGameData1)
                            //获取对比数据
                            let param1 = this.copyData(param)
                            param1.param._param.stime = this.getSecond(this.select.DdataTime)
                            param1.param._param.etime = this.getSecond(this.select.DdataTime, false)
                            param1.param._func = 'GetGameCompareInfo2'
                            //对比2游戏数据
                            TransTopReq(param1).then((res1) => {
                                let thisValue = this.proGameCompData(compGameData1, res1)
                                let param3 = this.copyData(param1)
                                param3.param._func = 'GetNewPlatfromData'
                                //对比2平台数据
                                TransTopReq(param3).then((res3) => {
                                    this.proPlatCompData(res3, thisValue)
                                    this.toHttp(httpList, dateMap, loadingArr)
                                })
                            })
                        })
                    })
                    .catch((err) => {
                        this.toHttp(httpList, dateMap, loadingArr)
                    })
            }
        },
        //处理基本游戏数据 参数==>游戏数据 合计数据 请求参数
        proGameBaseData(compGameData1, param) {
            let compAllBaseData = this.all[0]
            let dateName = moment(this.select.dataTime).format('YYYY-MM-DD')
            compGameData1.idate = dateName
            compGameData1.app_id = param.app_id
            compGameData1.app_name = param.app_name
            compGameData1.type = 0
            delete compGameData1.data

            //设置对比游戏基本数据
            compAllBaseData.idate = dateName
            compAllBaseData.new_user_num += compGameData1.new_user_num
            compAllBaseData.pay_bet_num += compGameData1.pay_bet_num
            compAllBaseData.pay_user_num += compGameData1.pay_user_num
            compAllBaseData.pay_total_times += compGameData1.pay_total_times
            compAllBaseData.r_pay_user_num += compGameData1.r_pay_user_num
            compAllBaseData.r_pay_user_sum += compGameData1.r_pay_user_sum
        },

        //处理基本平台数据 平台返回数据 基本游戏数据
        proPlatBaseData(res, compGameData1) {
            //合计数据第一行
            let compAllBaseData = this.all[0]
            let dayData = res._param.data[0]
            let active_user_num = 0
            let new_user_pay_num = 0
            if (dayData) {
                active_user_num = dayData.active_user_num
                new_user_pay_num = dayData.new_user_pay_num
            }
            res.pay_winner_rate = this.calcRateItem(res.pay_winner_rate, 1)

            //设置查询时间数据平台数据
            compGameData1.active_user_num = active_user_num
            compGameData1.new_user_pay_num = new_user_pay_num
            compGameData1.pay_ave = res._param.pay_ave || 0
            compGameData1.pay_winner = res._param.pay_winner || 0
            compGameData1.pay_loser = res._param.pay_loser || 0
            compGameData1.pay_winner_loser = compGameData1.pay_winner + compGameData1.pay_loser
            compGameData1.pay_winner_rate = this.calcRateItem(compGameData1.pay_winner, compGameData1.pay_winner_loser)
            compGameData1.online_pay_all_num = res._param.online_pay_all_num
            compGameData1.online_pay_success_num = res._param.online_pay_success_num
            compGameData1.online_pay_rate = compGameData1.online_pay_all_num ? compGameData1.online_pay_success_num / compGameData1.online_pay_all_num : 0

            //修改合计数据平台数据
            compAllBaseData.new_user_pay_num += new_user_pay_num
            compAllBaseData.active_user_num += active_user_num
            compAllBaseData.pay_ave += res._param.pay_ave || 0
            compAllBaseData.pay_winner += res._param.pay_winner || 0
            compAllBaseData.pay_loser += res._param.pay_loser || 0
            compAllBaseData.pay_winner_loser += compAllBaseData.pay_winner + compAllBaseData.pay_loser
            compAllBaseData.pay_winner_rate = this.calcRateItem(compAllBaseData.pay_winner, compAllBaseData.pay_winner_loser)
            compAllBaseData.online_pay_all_num += res._param.online_pay_all_num
            compAllBaseData.online_pay_success_num += res._param.online_pay_success_num
            compAllBaseData.online_pay_rate = compAllBaseData.online_pay_all_num ? compAllBaseData.online_pay_success_num / compAllBaseData.online_pay_all_num : 0
        },
        //处理游戏对比日期数据
        proGameCompData(compGameData1, res) {
            let [compAllCompData, compAllCompData1, compAllCompData2, compAllCompData3] = this.all
            let dateName = moment(this.select.DdataTime).format('YYYY-MM-DD')
            let compGameData2 = res._param
            compGameData2.idate = dateName
            compGameData2.type = 0
            delete compGameData1.data

            compAllCompData1.idate = dateName
            compAllCompData1.new_user_num += compGameData2.new_user_num
            compAllCompData1.pay_bet_num += compGameData2.pay_bet_num
            compAllCompData1.pay_user_num += compGameData2.pay_user_num
            compAllCompData1.pay_total_times += compGameData2.pay_total_times
            compAllCompData1.r_pay_user_num += compGameData2.r_pay_user_num
            compAllCompData1.r_pay_user_sum += compGameData2.r_pay_user_sum

            //设置盘口数据差值
            let tableData2 = this.getAllItem('', 1)
            tableData2.idate = '差值'
            tableData2.new_user_num = compGameData1.new_user_num - compGameData2.new_user_num
            tableData2.pay_bet_num = compGameData1.pay_bet_num - compGameData2.pay_bet_num
            tableData2.pay_user_num = compGameData1.pay_user_num - compGameData2.pay_user_num
            tableData2.pay_total_times = compGameData1.pay_total_times - compGameData2.pay_total_times
            tableData2.r_pay_user_num = compGameData1.r_pay_user_num - compGameData2.r_pay_user_num
            tableData2.r_pay_user_sum = compGameData1.r_pay_user_sum - compGameData2.r_pay_user_sum

            //设置盘口数据环比
            let tableData3 = this.getAllItem('', 1)
            tableData3.idate = '环比'
            tableData3.new_user_num = this.calcRateItem(tableData2.new_user_num, compGameData2.new_user_num)
            tableData3.pay_bet_num = this.calcRateItem(tableData2.pay_bet_num, compGameData2.pay_bet_num)
            tableData3.pay_user_num = this.calcRateItem(tableData2.pay_user_num, compGameData2.pay_user_num)
            tableData3.pay_total_times = this.calcRateItem(tableData2.pay_total_times, compGameData2.pay_total_times)
            tableData3.r_pay_user_num = this.calcRateItem(tableData2.r_pay_user_num, compGameData2.r_pay_user_num)
            tableData3.r_pay_user_sum = this.calcRateItem(tableData2.r_pay_user_sum, compGameData2.r_pay_user_sum)

            compAllCompData2.type = 1
            compAllCompData2.idate = '差值'
            compAllCompData2.new_user_num = compAllCompData.new_user_num - compAllCompData1.new_user_num
            compAllCompData2.pay_bet_num = compAllCompData.pay_bet_num - compAllCompData1.pay_bet_num
            compAllCompData2.pay_user_num = compAllCompData.pay_user_num - compAllCompData1.pay_user_num
            compAllCompData2.pay_total_times = compAllCompData.pay_total_times - compAllCompData1.pay_total_times
            compAllCompData2.r_pay_user_num = compAllCompData.r_pay_user_num - compAllCompData1.r_pay_user_num
            compAllCompData2.r_pay_user_sum = compAllCompData.r_pay_user_sum - compAllCompData1.r_pay_user_sum

            compAllCompData3.type = 2
            compAllCompData3.idate = '环比'
            compAllCompData3.new_user_num = this.calcRateItem(compAllCompData2.new_user_num, compAllCompData1.new_user_num)
            compAllCompData3.pay_bet_num = this.calcRateItem(compAllCompData2.pay_bet_num, compAllCompData1.pay_bet_num)
            compAllCompData3.pay_user_num = this.calcRateItem(compAllCompData2.pay_user_num, compAllCompData1.pay_user_num)
            compAllCompData3.pay_total_times = this.calcRateItem(compAllCompData2.pay_total_times, compAllCompData1.pay_total_times)
            compAllCompData3.r_pay_user_num = this.calcRateItem(compAllCompData2.r_pay_user_num, compAllCompData1.r_pay_user_num)
            compAllCompData3.r_pay_user_sum = this.calcRateItem(compAllCompData2.r_pay_user_sum, compAllCompData1.r_pay_user_sum)

            return {
                data: compGameData1,
                data1: compGameData2,
                data2: tableData2,
                data3: tableData3
            }
        },
        //处理平台对比日期数据
        proPlatCompData(res, thisValue) {
            let { data, data1, data2, data3 } = thisValue
            let [compAllCompData, compAllCompData1, compAllCompData2, compAllCompData3] = this.all
            let dateName = moment(this.select.DdataTime).format('YYYY-MM-DD')
            let compAllBaseData = this.all[0]
            let dayData = res._param.data[0]
            let active_user_num = 0
            let new_user_pay_num = 0
            if (dayData) {
                active_user_num = dayData.active_user_num
                new_user_pay_num = dayData.new_user_pay_num
            }

            //修改当前请求平台数据
            data1.active_user_num = active_user_num
            data1.new_user_pay_num = new_user_pay_num
            data1.pay_ave = res._param.pay_ave || 0
            data1.pay_winner = res._param.pay_winner || 0
            data1.pay_loser = res._param.pay_loser || 0
            data1.pay_winner_loser = data1.pay_winner + data1.pay_loser
            data1.pay_winner_rate = this.calcRateItem(data1.pay_winner, data1.pay_winner_loser)
            data1.online_pay_all_num = res._param.online_pay_all_num
            data1.online_pay_success_num = res._param.online_pay_success_num
            data1.online_pay_rate = data1.online_pay_all_num ? data1.online_pay_success_num / data1.online_pay_all_num : 0

            //修改当前请求平台差值
            data2.active_user_num = data.active_user_num - data1.active_user_num
            data2.new_user_pay_num = data.new_user_pay_num - data1.new_user_pay_num
            data2.pay_ave = data.pay_ave - data1.pay_ave
            data2.pay_winner = data.pay_winner - data1.pay_winner
            data2.pay_loser = data.pay_loser - data1.pay_loser
            data2.pay_winner_loser = data.pay_winner_loser - data1.pay_winner_loser
            data2.pay_winner_rate = data.pay_winner_rate - data1.pay_winner_rate
            data2.online_pay_all_num = data.online_pay_all_num - data1.online_pay_all_num
            data2.online_pay_success_num = data.online_pay_success_num - data1.online_pay_success_num
            data2.online_pay_rate = data.online_pay_rate - data1.online_pay_rate

            //修改当前请求平台环比
            data3.active_user_num = this.calcRateItem(data2.active_user_num, data1.active_user_num)
            data3.new_user_pay_num = this.calcRateItem(data2.new_user_pay_num, data1.new_user_pay_num)
            data3.pay_ave = this.calcRateItem(data2.pay_ave, data1.pay_ave)
            data3.pay_winner = this.calcRateItem(data2.pay_winner, data1.pay_winner)
            data3.pay_loser = this.calcRateItem(data2.pay_loser, data1.pay_loser)
            data3.pay_winner_loser = this.calcRateItem(data2.pay_winner_loser, data1.pay_winner_loser)
            data3.pay_winner_rate = data2.pay_winner_rate
            // this.calcRateItem(
            //     data2.pay_winner_rate,
            //     data1.pay_winner_rate
            // );
            data3.online_pay_all_num = this.calcRateItem(data2.online_pay_all_num, data1.online_pay_all_num)
            data3.online_pay_success_num = this.calcRateItem(data2.online_pay_success_num, data1.online_pay_success_num)
            data3.online_pay_rate = this.calcRateItem(data2.online_pay_rate, data1.online_pay_rate)

            //修改合计对比日期数据
            compAllCompData1.active_user_num += active_user_num
            compAllCompData1.new_user_pay_num += new_user_pay_num
            compAllCompData1.pay_ave += res._param.pay_ave || 0
            compAllCompData1.pay_winner += res._param.pay_winner || 0
            compAllCompData1.pay_loser += res._param.pay_loser || 0
            compAllCompData1.pay_winner_loser += compAllCompData1.pay_winner + compAllCompData1.pay_loser
            compAllCompData1.pay_winner_rate = this.calcRateItem(compAllCompData1.pay_winner, compAllCompData1.pay_winner_loser)
            compAllCompData1.online_pay_all_num += res._param.online_pay_all_num
            compAllCompData1.online_pay_success_num += res._param.online_pay_success_num
            compAllCompData1.online_pay_rate = this.calcRateItem(compAllCompData1.online_pay_success_num, compAllCompData1.online_pay_all_num)

            //修改合计差值数据
            compAllCompData2.active_user_num = compAllCompData.active_user_num - compAllCompData1.active_user_num
            compAllCompData2.new_user_pay_num = compAllCompData.new_user_pay_num - compAllCompData1.new_user_pay_num
            compAllCompData2.pay_ave = compAllCompData.pay_ave - compAllCompData1.pay_ave
            compAllCompData2.pay_winner = compAllCompData.pay_winner - compAllCompData1.pay_winner
            compAllCompData2.pay_loser = compAllCompData.pay_loser - compAllCompData1.pay_loser
            compAllCompData2.pay_winner_loser = compAllCompData.pay_winner_loser - compAllCompData1.pay_winner_loser
            compAllCompData2.pay_winner_rate = compAllCompData.pay_winner_rate - compAllCompData1.pay_winner_rate
            compAllCompData2.online_pay_all_num = compAllCompData.online_pay_all_num - compAllCompData1.online_pay_all_num
            compAllCompData2.online_pay_success_num = compAllCompData.online_pay_success_num - compAllCompData1.online_pay_success_num
            compAllCompData2.online_pay_rate = compAllCompData.online_pay_rate - compAllCompData1.online_pay_rate

            //修改合计环比数据
            compAllCompData3.active_user_num = this.calcRateItem(compAllCompData2.active_user_num, compAllCompData1.active_user_num)
            compAllCompData3.new_user_pay_num = this.calcRateItem(compAllCompData2.new_user_pay_num, compAllCompData1.new_user_pay_num)
            compAllCompData3.pay_ave = this.calcRateItem(compAllCompData2.pay_ave, compAllCompData1.pay_ave)
            compAllCompData3.pay_winner = this.calcRateItem(compAllCompData2.pay_winner, compAllCompData1.pay_winner)
            compAllCompData3.pay_loser = this.calcRateItem(compAllCompData2.pay_loser, compAllCompData1.pay_loser)
            compAllCompData3.pay_winner_loser = this.calcRateItem(compAllCompData2.pay_winner_loser, compAllCompData1.pay_winner_loser)
            compAllCompData3.pay_winner_rate = compAllCompData2.pay_winner_rate
            // this.calcRateItem(
            //     compAllCompData2.pay_winner_rate,
            //     compAllCompData1.pay_winner_rate
            // );
            compAllCompData3.online_pay_all_num = this.calcRateItem(compAllCompData2.online_pay_all_num, compAllCompData1.online_pay_all_num)
            compAllCompData3.online_pay_success_num = this.calcRateItem(compAllCompData2.online_pay_success_num, compAllCompData1.online_pay_success_num)
            compAllCompData3.online_pay_rate = this.calcRateItem(compAllCompData2.online_pay_rate, compAllCompData1.online_pay_rate)

            this.table.data.splice(this.table.data.length - 4, this.table.data.length)
            this.table.data = [...this.table.data, ...[data, data1, data2, data3], ...this.all]
        },
        //分组变化清空盘口选择项
        updateSelect() {
            this.table.params.app_ids = []
        },
        //计算百分比
        calcRateItem(val1, val2) {
            return val2 ? Math.round((val1 / val2) * 10000) / 10000 : 0
        },
        rColItem(h, params, isMoney = false) {
            let field = params.column.key
            let isFour = params.row.idate == '环比'
            let value = params.row[field]
            let type = params.row.type
            if (isMoney && !isFour) {
                value = this.getCustomFixed(value / 10000)
            }
            let color = this.rCol(type, value)
            let str = !isFour ? value : (value * 100).toFixed(2) + '%'
            return h('span', { style: { color } }, str)
        },
        rCol(type, num) {
            if (type) {
                if (num > 0) {
                    return 'red'
                } else if (num == 0) {
                    return '#333'
                } else if (num < 0) {
                    return '#32CD32'
                }
            } else {
                return '#333'
            }
        },
        toPdf() {
            this.maxHeight = null
            this.$nextTick(async () => {
                await this.eleToPdf()
                this.maxHeight = 800
            })
        },
        allInit() {
            return [this.getAllItem('合计', 0), this.getAllItem('', 0), this.getAllItem('', 1), this.getAllItem('', 1)]
        },
        getAllItem(app_name = '', type = 0) {
            return {
                type,
                app_name,
                idate: '',
                new_user_num: 0,
                pay_bet_num: 0,
                pay_user_num: 0,
                pay_total_times: 0,
                r_pay_user_num: 0,
                r_pay_user_sum: 0,
                online_pay_rate: 0,
                online_pay_all_num: 0,
                online_pay_success_num: 0,
                new_user_pay_num: 0,
                pay_ave: 0,
                active_user_num: 0,
                pay_winner: 0,
                pay_loser: 0,
                pay_winner_loser: 0,
                pay_winner_rate: 0
            }
        },
        initFunc() {
            let arr = [this.getinitPlatId()]
            this.table.params.platids = arr
            this.TransTopReq()
        }
    },

    created() {
        this.initFunc()
    }
}
</script>
<style lang="less" scoped>
.btn_batch {
    margin-right: 12px;
}
</style>
